export default __webpack_public_path__ + "assets/img_webp/back_icon_n_item_04.2095eeed.png";